
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/asia",
      function () {
        return require("private-next-pages/asia.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/asia"])
      });
    }
  